<mat-form-field
	appearance="outline"
	color="primary"
	class="full-width date-size"
>
	<mat-label>{{ label }}</mat-label>
	<mat-date-range-input
		[formGroup]="range"
		[rangePicker]="picker"
		[min]="minDate"
		[max]="maxDate"
	>
		<input readonly matStartDate formControlName="start" placeholder="Desde" />
		<input
			readonly
			matEndDate
			formControlName="end"
			placeholder="Hasta"
			[min]="minDateEnd"
		/>
	</mat-date-range-input>
	<mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
	<mat-date-range-picker #picker [calendarHeaderComponent]="customHeader">
		<mat-datepicker-actions>
			<button mat-button color="primary" matDatepickerCancel class="date-btn">
				Cancelar
			</button>
			<button mat-button color="primary" matDatepickerApply class="date-btn">
				Aceptar
			</button>
		</mat-datepicker-actions>
	</mat-date-range-picker>
	@if (
		range.controls['start'].hasError('required') ||
		range.controls['end'].hasError('required')
	) {
		<mat-error>Debe elegir un rango de fechas.</mat-error>
	}
</mat-form-field>
